import { defineSlotRecipe } from '@chakra-ui/react';

export const iconSlotRecipe = defineSlotRecipe({
    slots: ['box', 'icon'],
    defaultVariants: {
        size: 'md',
        variant: 'default',
    },
    base: {
        icon: {
            display: 'inline-block',
            lineHeight: 1,
            flexShrink: 0,
            verticalAlign: 'middle',
            width: '1em',
            height: '1em',
        },
        box: {
            display: 'inline-flex',
            p: '1.125em',
            borderRadius: 'full',
        },
    },
    variants: {
        size: {
            '2xs': {
                box: {
                    p: '0.5em',
                },
                icon: {
                    fontSize: 'xs',
                    '--icon-stroke': 1.25,
                },
            },
            xs: {
                icon: {
                    fontSize: 'md',
                    '--icon-stroke': 1.25,
                },
            },
            sm: {
                icon: {
                    fontSize: 'lg',
                    '--icon-stroke': 1.5,
                },
            },
            md: {
                icon: {
                    fontSize: '2xl',
                    '--icon-stroke': 1.75,
                },
            },
            lg: {
                icon: {
                    fontSize: '3xl',
                    '--icon-stroke': 1.75,
                },
            },
            xl: {
                icon: {
                    fontSize: '4xl',
                    '--icon-stroke': 1.75,
                },
            },
            '2xl': {
                icon: {
                    fontSize: '6xl',
                    '--icon-stroke': 3.5,
                },
            },
            '4xl': {
                icon: {
                    fontSize: '8xl',
                    '--icon-stroke': 4.5,
                },
            },
            '8xl': {
                icon: {
                    fontSize: '9xl',
                    '--icon-stroke': 1.75,
                },
            },
        },
        variant: {
            default: {},
            solid: {
                box: {
                    bgColor: 'colorPalette.solid',
                    color: 'colorPalette.contrast',
                },
            },
            subtle: {
                box: {
                    color: 'colorPalette.fg',
                    bgColor: 'colorPalette.subtle',
                },
            },
        },
    },
});
